import { Model as BaseModel } from "vue-api-query";
import { ApiClient } from "@/apis/AxiosClient";

BaseModel.$http = new ApiClient(BaseModel.baseURL);
export default class Model extends BaseModel {
    // Define a base url for a REST API
    baseURL() {
        return "https://" + window.location.host + import.meta.env.VITE_API_PATH;
    }

    // Implement a default request method
    request(config) {
        return this.$http.request(config);
    }
}
